import React from 'react';

import './index.less';

import { IngestionSourceParametersType } from '../../../../../../gamma-api';
import IbIcon from '../../../../../components/common/IbIcon';
import IbTypography from '../../../../../components/common/IbTypography';
import IbTextHighlighter from '../../../../../components/common/IbTextHighlighter';
import { getSourceTypeIconName } from '../../../../../utils/ingestionSourceUtil';

import { MAIN_CLASS_NAME } from './const';

export interface ISourceTitleProps {
  type: IngestionSourceParametersType;
  name: string;
  searchText?: string;
}

const SourceTitle: React.FC<ISourceTitleProps> = ({ type, name, searchText }) => {
  const renderIcon = () => <IbIcon iconName={getSourceTypeIconName(type)} size={20} />;

  const renderName = () => (
    <IbTypography.Paragraph type="secondary">
      <IbTextHighlighter highlightedText={searchText} text={name} />
    </IbTypography.Paragraph>
  );

  return (
    <span className={MAIN_CLASS_NAME}>
      {renderIcon()}
      {renderName()}
    </span>
  );
};

export default SourceTitle;
